import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import ShopRecommendations from './ShopRecommendations';

export const getShopRecommendationsWidgetConfig = ({
  t,
  dispatch,
}): WidgetConfig => ({
  viewComponent: ShopRecommendations,
});
